import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Sprout, Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(res.data.user);
        // Clean fragment from URL & go to profile (first-time) or home
        const needsOnboarding = !res.data.user.city || !res.data.user.phone;
        window.history.replaceState({}, document.title, "/");
        navigate(needsOnboarding ? "/profile?welcome=1" : "/", { replace: true });
      } catch (e) {
        console.error("Session exchange failed", e);
        navigate("/login?error=auth_failed", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div data-testid="auth-callback-loader" className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="card-gc p-8 flex flex-col items-center gap-3">
        <div className="w-14 h-14 rounded-2xl bg-[#1E4D2B] text-white flex items-center justify-center">
          <Sprout size={26} />
        </div>
        <Loader2 className="animate-spin text-[#1E4D2B]" size={28} />
        <p className="text-stone-700 font-medium">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
